import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faChevronDown, faMousePointer } from '@fortawesome/free-solid-svg-icons';
import { MailOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { getThemePreviewStyleVars } from '../../../contexts/CustomizationContext';

const ThemeLivePreview = ({ sidebarTheme }) => {
    const { t } = useTranslation();
    const previewStyle = getThemePreviewStyleVars(sidebarTheme);
    return (
        <div id="theme-preview-root" className="theme-live-preview-wrapper" style={Object.keys(previewStyle).length ? previewStyle : undefined}>
            <div className="theme-live-preview-inner">
                <header className="theme-preview-header">
                    <div className="theme-preview-main">
                        <span className="theme-preview-logo">{t('admin.customization.themePreviewCompanyName')}</span>
                        <nav className="theme-preview-nav">
                                <span className="theme-preview-nav-bell-wrap">
                                    <FontAwesomeIcon icon={faBell} className="theme-preview-nav-bell" />
                                    <span className="theme-preview-nav-badge">3</span>
                                </span>
                                <div className="theme-preview-dropdown-wrap">
                                    <span className="theme-preview-nav-item theme-preview-dropdown-trigger">
                                        {t('admin.customization.themePreviewMenu')} <FontAwesomeIcon icon={faChevronDown} className="theme-preview-dropdown-arrow" />
                                    </span>
                                    <div className="theme-preview-dropdown-open">
                                        <div className="theme-preview-dropdown-item">{t('layout.navigation.mailbox')}</div>
                                        <div className="theme-preview-dropdown-item theme-preview-dropdown-item-hover">
                                            {t('layout.navigation.userSettings')}
                                            <FontAwesomeIcon icon={faMousePointer} className="theme-preview-dropdown-cursor" />
                                        </div>
                                    </div>
                                </div>
                                <span className="theme-preview-auth-btn theme-preview-auth-btn-login">{t('layout.navigation.login')}</span>
                                <span className="theme-preview-auth-btn theme-preview-auth-btn-signup">{t('layout.navigation.signUp')}</span>
                                <span className="theme-preview-auth-btn theme-preview-auth-btn-guest">{t('contactsMailbox.becomeGuestTitle')}</span>
                            </nav>
                        </div>
                </header>
                <div className="theme-preview-body">
                    <aside className="theme-preview-sidebar">
                        <div className="theme-preview-sidebar-hub">
                            <div className="theme-preview-hub-dots">
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot theme-preview-hub-dot-center" />
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot" />
                                <span className="theme-preview-hub-dot" />
                            </div>
                        </div>
                        <div className="theme-preview-sidebar-menu-items">
                            <span className="theme-preview-sidebar-item">
                                <span className="theme-preview-sidebar-icon"><MailOutlined /></span>
                            </span>
                            <span className="theme-preview-sidebar-item active">
                                <span className="theme-preview-sidebar-icon"><SettingOutlined /></span>
                            </span>
                            <div className="theme-preview-sidebar-divider" />
                            <span className="theme-preview-sidebar-item theme-preview-sidebar-language">
                                <span className="theme-preview-sidebar-icon theme-preview-sidebar-flag">🇫🇷</span>
                            </span>
                            <span className="theme-preview-sidebar-item theme-preview-sidebar-logout">
                                <span className="theme-preview-sidebar-icon"><LogoutOutlined /></span>
                            </span>
                        </div>
                    </aside>
                    <div className="theme-preview-hero">
                    <h1 className="theme-preview-title">{t('admin.customization.themePreviewHeroTitle')}</h1>
                    <p className="theme-preview-subtitle">{t('admin.customization.themePreviewHeroSubtitle')}</p>
                    <div className="theme-preview-buttons">
                        <button type="button" className="theme-preview-btn theme-preview-btn-confirm">{t('admin.customization.themePreviewConfirm')}</button>
                        <button type="button" className="theme-preview-btn theme-preview-btn-cancel">{t('admin.customization.themePreviewCancel')}</button>
                    </div>
                    </div>
                </div>
                <footer className="theme-preview-footer">
                    <span>{t('admin.customization.themePreviewFooter')}</span>
                </footer>
            </div>
        </div>
    );
};

export default ThemeLivePreview;
